import React, { useState } from 'react';
import { FallbackProps } from 'react-error-boundary';
import { EntAlertView } from '@ent-ui-kit/react';
import { genericErrorMessage } from '../../utils/copyText';
import ModalWrapper from '../ModalWrapper';

const GlobalErrorModal = ({ resetErrorBoundary }: FallbackProps) => {
  const [show, setShow] = useState(true);
  const handleClose = () => {
    resetErrorBoundary();
    setShow(false);
  };

  return (
    <ModalWrapper
      canShow={show}
      onHide={handleClose}
      ctaCopy="Close"
      ctaAction={handleClose}
    >
      <EntAlertView type="error" title={genericErrorMessage} />
    </ModalWrapper>
  );
};

export default GlobalErrorModal;
